import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    configuration: null,
    results: null,
    labels: null,
    background: 'home',
    history: []
};

export const productFinderSlice = createSlice({
    name: 'productFinder',
    initialState: initialState,
    reducers: {
        setConfiguration(state, action) {
            state.configuration = action.payload;
        },
        setResults(state, action) {
            state.results = action.payload
        },
        setLabels(state, action) {
            state.labels = action.payload
        },
        setBackground(state, action) {
            state.background = action.payload
        },
        // setHistory(state, action) {
        //     state.history = action.payload
        // },
        addToHistory(state, action) {
            state.history = [...state.history, action.payload];
        },
        historyBack(state, action) {
            state.history.pop();
        }
    },
});

export const getConfiguration = state => state.productFinder.configuration;
export const getResults = state => state.productFinder.results;
export const getLabels = state => state.productFinder.labels;
export const getBackground = state => state.productFinder.background;
//export const getPreviousPage = state => state.productFinder.previousPage;
export const getHistory = state => state.productFinder.history;

export const {
    setConfiguration,
    setResults,
    setLabels,
    setBackground,
    addToHistory,
    historyBack
} = productFinderSlice.actions;

export default productFinderSlice.reducer;

